import React from "react";
import "./ErrorPage.css";
import PropTypes from "prop-types";

const ErrorPage = ({ errors, homeUrl, setApiErrors }) => {
  const isSingleError = errors.length === 1;

  const handleRefresh = () => window.location.reload();
  const handleReturnHome = () => (
    setApiErrors([]), (window.location.href = homeUrl)
  );

  return (
    <div className="error-page-container">
      <div className="error-box">
        <h3 className="error-title">
          {isSingleError
            ? "An Error Has Occurred"
            : "Some Errors Have Occurred"}
        </h3>

        <p className="error-message">
          We encountered an issue fetching necessary application data.
        </p>

        <ul className="error-list">
          {errors.map((error, i) => (
            <li key={`${error.endpoint || error.header || "Error"}-${error.status}-${i}`}>
              <strong>{error.header || "Error"}</strong>
              {error.status && (
                <span className="error-status">
                  {" "}
                  - {error.status}
                </span>
              )}
              {error.endpoint && (
                <div className="error-endpoint">
                  <code>{error.method || "GET"} {error.endpoint}</code>
                </div>
              )}
              {error.message && (
                <div className="error-detail">{error.message}</div>
              )}
            </li>
          ))}
        </ul>

        <div className="error-actions">
          <button onClick={handleRefresh} className="refresh-button">
            Refresh
          </button>
          <button onClick={handleReturnHome} className="home-button">
            Return Home
          </button>
        </div>
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string,
      status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      message: PropTypes.string,
      endpoint: PropTypes.string,
      method: PropTypes.string,
    })
  ).isRequired,
  homeUrl: PropTypes.string, // optional; defaults to "/"
  setApiErrors: PropTypes.func.isRequired,
};

export default ErrorPage;
